import React, { createContext, useState, useEffect, useContext } from "react";
import { getServices, type Service } from "../api/servicesApi";

interface ServicesContextType {
    services: Service[];
    loading: boolean;
    error: string | null;
    refresh: () => Promise<void>;
}

const ServicesContext = createContext<ServicesContextType>({
    services: [],
    loading: false,
    error: null,
    refresh: async () => {}
});

export const ServicesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [services, setServices] = useState<Service[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchServices = async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await getServices();
            setServices(data);
        } catch (err) {
            console.error("Ошибка при загрузке услуг:", err);
            setError("Не удалось загрузить услуги");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (services.length === 0) fetchServices(); // fetch только если данных нет
    }, []);

    return (
        <ServicesContext.Provider value={{ services, loading, error, refresh: fetchServices }}>
            {children}
        </ServicesContext.Provider>
    );
};

export const useServices = () => useContext(ServicesContext);
